<template>
  <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination" :key="reInit"></data-list>
</template>
<script>
import DataList from '@/components/DataList.vue'
export default {
  data () {
    return {
      listPayloadObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        addNewRoute: () => this.$router.push('users/actions'),
        isTechRole: JSON.parse(this.$cookie.get(process.env.VUE_APP_USER)).role_id === 3,
        headers: [],
        list: [],
        loading: true,
        hasFilters: false,
        editProp: 'name',
        editURL: (item) => `users/actions/${item.id}`,
        orderDetails: [{
          prop: 'ongoing_orders',
          value: 2
        }, {
          prop: 'completed_orders',
          value: 3
        }, {
          prop: 'invoiced_orders',
          value: 5
        }]
      },
      filterObj: {
        start: '',
        end: ''
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.USER_INDEX) ? this.$store.state.USER_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'users',
      headersForAdmin: [],
      reInit: 0
    }
  },
  components: {
    DataList
  },
  computed: {
    headers: {
      get () {
        const heads = [{
          text: this.$t('message.user.initial'),
          value: 'initial',
          width: '10%'
        }, {
          text: this.$t('message.customer.name'),
          value: 'name',
          width: '20%'
        }, {
          text: this.$t('message.customer.email'),
          value: 'email',
          width: '20%'
        }, {
          text: this.$t('message.login.userName'),
          value: 'username',
          width: '25%'
        }, {
          text: this.$t('message.customer.mobile'),
          value: 'mobile',
          width: '20%'
        }, {
          text: this.$t('message.user.role'),
          value: 'role_name',
          width: '25%'
        }]
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.headersForAdmin = heads
        return this.headersForAdmin
      },
      set (value) {
        this.headersForAdmin = value
      }
    },
    status () {
      return [{
        text: this.$t('message.customer.active'),
        value: 1
      }, {
        text: this.$t('message.customer.Inactive'),
        value: 2
      }, {
        text: this.$t('message.tickets.all'),
        value: 3
      }]
    },
    periods () {
      return [{
        text: this.$t('message.customer.current'),
        value: 1
      }, {
        text: this.$t('message.tickets.all'),
        value: 2
      }, {
        text: this.$t('message.customer.thisYear'),
        value: 3
      }, {
        text: this.$t('message.customer.lastYear'),
        value: 4
      }]
    }
  },
  watch: {
    pagination (val) {
      const model = { type: 'EMPLOYEE_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    'filterObj.start' (val) {
      this.getListHandler()
    },
    'filterObj.end' (val) {
      this.getListHandler()
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      const { search } = this.$formatter.cloneVariable(this.pagination)
      const fromDate = this.filterObj.start ? this.$formatter.formatDate(this.filterObj.start, 'DD.MM.YYYY', 'YYYY-MM-DD') : null
      const toDate = this.filterObj.end ? this.$formatter.formatDate(this.filterObj.end, 'DD.MM.YYYY', 'YYYY-MM-DD') : null
      const model = {
        start: fromDate,
        end: toDate,
        status: this.filterObj.status || 0,
        period: this.filterObj.period || 0,
        search: search
      }
      this.$_executeApi('post', `${this.MODULE}/get_employees`, model)
        .then((response) => {
          const result = response.data
          result.forEach(element => {
            if (element.role_id) {
              const result = this.listOfUserRoles.find(x => x.id === element.role_id)
              if (result) element.role_name = result.name
            }
          })
          this.listPayloadObj.list = result
        }).finally(() => {
          this.listPayloadObj.loading = false
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
